import React, { Fragment, useState, useEffect } from 'react';
import { Modal, FormControl, FormGroup, FormControlLabel, Checkbox, withStyles } from '@material-ui/core';
import { Row, Col, Table, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faProcedures, faCrutch, faWheelchair, faHeadSideCough, faPlusSquare, faAmbulance, faLungs
} from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import BlockIcon from '@material-ui/icons/Block';
import SaveIcon from '@material-ui/icons/Save';
import ModalUI from '../../../../shared/components/Modal';

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const FormEspecialReq = ({
    selectedItems,
    setReqHospitalizado,
    setReqSillas,
    setReqMuletas,
    setReqSintomas,
    setReqOxigeno,
    setReqCamilla,
    setReqAmbulancia,
    setReqNinguno,
    setReqOtro,
    setReqOtroReq,
    disabledForm,
    disableEspReqForm,
    setDisableEspReqForm,
    id_admision,
    editReqEsp,
    setEditReqEsp }) => {

    const [disableFormAdm, setDisableFormAdm] = useState(false);
    //const [editReqEsp, setEditReqEsp] = useState(false);
    const [idAdmision, setIdAdmision] = useState(0);
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const [specialReq, setSpecialReq] = useState({
        hospitalizado: false,
        sillas: false,
        muletas: false,
        sintomas_respiratorios: false,
        oxigeno: false,
        camilla: false,
        ambulancia: false,
        ninguno: false,
        otro: false,
        otroReq: ''
    })

    useEffect(() => {
        if (id_admision !== null && id_admision !== undefined && id_admision !== '') {
            if (editReqEsp) {
                setDisableFormAdm(false);
            } else {
                setDisableFormAdm(true);
            }
            setIdAdmision(id_admision);
        }
    }, [])

    useEffect(() => {
        if(selectedItems!== undefined && selectedItems !== null && typeof selectedItems !== '{}'){
            setSpecialReq(prevState => { return {...prevState, 
                hospitalizado: selectedItems.hasOwnProperty('hospitalizado') ? selectedItems.hospitalizado : false ,
                sillas: selectedItems.hasOwnProperty('sillas') ? selectedItems.sillas : false ,
                muletas: selectedItems.hasOwnProperty('muletas') ? selectedItems.muletas : false ,
                sintomas_respiratorios: selectedItems.hasOwnProperty('sintomas_respiratorios') ? selectedItems.sintomas_respiratorios : false ,
                oxigeno: selectedItems.hasOwnProperty('oxigeno') ? selectedItems.oxigeno : false ,
                camilla: selectedItems.hasOwnProperty('camilla') ? selectedItems.camilla : false ,
                ambulancia: selectedItems.hasOwnProperty('ambulancia') ? selectedItems.ambulancia : false ,
                ninguno: selectedItems.hasOwnProperty('ninguno') ? selectedItems.ninguno : false ,
                otro: selectedItems.hasOwnProperty('otro') ? selectedItems.otro : false ,
                otroReq:  selectedItems.hasOwnProperty('otroReq') ? selectedItems.otroReq : false }
            })
        }
        
    }, [selectedItems]);

   
    

    const updateReqEsp = () => {
        let data = {
            id_admision: id_admision,
            requerimientos_especiales: selectedItems
        }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/actualizar-requerimientos-especiales', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                setOpenAlert(true);
                setModalAlert({
                    message: "Req. Especiales actualizados con exito",
                    color: 'success',
                    title: "Exitoso!"
                });
                setDisableFormAdm(true)
                setEditReqEsp(false)
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <Fragment>

            <div style={{ border: '1px solid #CACDD1', borderRadius: 5, marginTop: 5 }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'initial' }}>
                    <div style={{ marginLeft: 10, marginTop: 10 }}>
                        <h4>Requerimientos Especiales</h4>
                    </div>
                    <div style={{ marginLeft: '1em' }}>
                        {
                            idAdmision !== null && idAdmision !== undefined && idAdmision !== '' && idAdmision !== 0 ?
                                editReqEsp == false ?
                                    <Tooltip title="Editar Requerimientos Especiales">
                                        <IconButton aria-label="upload picture" component="span"
                                            onClick={() => {
                                                setEditReqEsp(true);
                                                setDisableFormAdm(false);
                                                if (specialReq.ninguno === true) {
                                                    setDisableEspReqForm(true)
                                                }
                                            }}>
                                            <EditOutlinedIcon />
                                        </IconButton>
                                    </Tooltip> : <>
                                        <Tooltip title="Actualizar Datos">
                                            <IconButton aria-label="upload picture" component="span"
                                                onClick={() => {
                                                    //this.updateAdditionalPatientInformation();
                                                    updateReqEsp();
                                                }}>
                                                <SaveIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Cancelar Edición">
                                            <IconButton aria-label="upload picture" component="span"
                                                onClick={() => {
                                                    //this.setState({ womanInformationEdit: false });
                                                    setEditReqEsp(false);
                                                    setDisableFormAdm(true);
                                                }}>
                                                <BlockIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </>
                                : null
                        }
                    </div>
                </div>
                <div style={{ margin: 5 }}>
                    <FormGroup style={{ width: '100%', margin: 5 }}>
                        <Row xs={1}>
                            <Col md={4}>
                                <FontAwesomeIcon icon={faPlusSquare} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox
                                            color="default"
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                            checked={specialReq.hospitalizado}
                                            onChange={(e, checked) => {
                                                setReqHospitalizado(checked);
                                            }} />
                                    }
                                    label="Hospitalizado"
                                />
                            </Col>
                            <Col md={4}>
                                <FontAwesomeIcon icon={faWheelchair} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox
                                            checked={specialReq.sillas}
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                            onChange={(e, checked) => {
                                                setReqSillas(checked);
                                            }}
                                            color="default" />
                                    }
                                    label="Sillas de ruedas"
                                />

                            </Col>
                            {/* <Col md={4}>
                                <FontAwesomeIcon icon={faCrutch} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e, checked) => {
                                                setReqMuletas(checked);
                                            }}
                                            checked={specialReq.muletas}
                                            disabled={disabledForm || disableEspReqForm }
                                        />}
                                    label="Muletas" />
                            </Col> */}
                            <Col md={4}>
                                <FontAwesomeIcon icon={faHeadSideCough} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e, checked) => {
                                                setReqSintomas(checked);
                                            }}
                                            checked={specialReq.sintomas_respiratorios}
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                        />}
                                    label="Sintomas respitarios (Covid)" />
                            </Col>

                        </Row>
                        <Row xs={1}>
                            <Col md={4}>
                                <FontAwesomeIcon icon={faLungs} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e, checked) => {
                                                setReqOxigeno(checked);
                                            }}
                                            checked={specialReq.oxigeno}
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                        />}
                                    label="Oxigeno" />
                            </Col>
                            <Col md={4}>
                                <FontAwesomeIcon icon={faProcedures} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e, checked) => {
                                                setReqCamilla(checked);
                                            }}
                                            checked={specialReq.camilla}
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                        />}
                                    label="Camilla" />
                            </Col>
                            <Col md={4}>
                                <FontAwesomeIcon icon={faAmbulance} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e, checked) => {
                                                setReqAmbulancia(checked);
                                            }}
                                            checked={specialReq.ambulancia}
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                        />}
                                    label="Ambulancia" />
                            </Col>
                        </Row>
                        <Row xs={1}>
                            <Col md={4}>
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e) => {
                                                setReqNinguno(e.target.checked)
                                            }}
                                            checked={specialReq.ninguno}
                                            //disabled={disabledForm}
                                            disabled={disableFormAdm}
                                        />}
                                    label="Ninguno"
                                    style={{ marginLeft: 30 }} />
                            </Col>
                            <Col md={4}>
                                <FormControlLabel
                                    control={
                                        <MedicalCheckbox color="default"
                                            onChange={(e) => {
                                                setReqOtro(e.target.checked)
                                            }}
                                            checked={specialReq.otro}
                                            //disabled={disabledForm || disableEspReqForm }
                                            disabled={disableEspReqForm || disableFormAdm}
                                        />}
                                    label="Otro"
                                    style={{ marginLeft: 30 }} />
                            </Col>
                            <Col md={4}>
                                {specialReq.otro == true ?
                                    <TextField
                                        id="another_requiriment"
                                        label="Otro Requerimiento"
                                        type="text"
                                        style={{ marginLeft: 30 }}
                                        disabled={disableFormAdm}
                                        value={selectedItems.otroReq}
                                        onChange={(e) => {
                                            setReqOtroReq(e.target.value)
                                        }}
                                    />
                                    : null}
                            </Col>
                        </Row>

                    </FormGroup>
                </div>
            </div>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment>
    );
};

export default FormEspecialReq;
